export function LayoutLoading() {
  return (
    <div className="h-screen w-full flex justify-center items-center">
      <i className="i-mhi-loading color-primary h-25 w-25" />
    </div>
  );
}
